module.exports = __webpack_public_path__ + "img/02.64c7d2bd.png";